module.exports = __webpack_public_path__ + "static/paraplan-fc559cb0f9eff3f256a4bf109d520816.png";